export const observer = (element: any, callback: Function, params = {}) => {
  let timeoutId: any;

  if (element.__isObserved) {
    return;
  }

  const obs = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback(entry);
          obs.unobserve(element);
          delete element.__isObserved;
        }, 500);
      } else {
        clearTimeout(timeoutId);
      }
    },
    {
      threshold: 0.1,
      ...params,
    },
  );

  obs.observe(element);
  element.__isObserved = true;
};
